import activityWall from './activityWall';
import agency from './agency';
import document from './document';
import stock from './stock';
import ticket from './ticket';
import customer from './customer';
import site from './site';
import deal from './deal';
import request from './request';
import contact from './contact';
import employee from './employee';
import collaborative from './collaborative';
import intervention from './intervention';
import interventionOrder from './interventionOrder';
import legacyProduct from './legacyProduct';
import deliveryOrder from './deliveryOrder';
import ranking from './ranking';
import gaming from './gaming';

export default {
  activityWall,
  agency,
  collaborative,
  contact,
  customer,
  deal,
  deliveryOrder,
  document,
  employee,
  intervention,
  interventionOrder,
  legacyProduct,
  ranking,
  gaming,
  request,
  site,
  stock,
  ticket,
};
